import { Link } from "react-router-dom";
import { site, navItems } from "@/mocks/site";
import { categories, hotKeywords } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100 mt-16 md:mt-24">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-emotion-laugh-line"></i>
              </span>
              <span className="text-lg font-heading text-background-50">{site.brand}</span>
            </div>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">{site.slogan}。吃瓜娱乐二创聚集地，表情包、段子、神回复与梗图每日上新。</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              <a href={`mailto:${site.email}`} className="hover:text-background-50 transition-colors">
                {site.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="text-sm text-background-50 tracking-wide">内容频道</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/${category.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm text-background-50 tracking-wide">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about#submit"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  投稿联系
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm text-background-50 tracking-wide">大家在搜</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotKeywords.map((word) => (
                <span
                  key={word}
                  className="px-2.5 py-1 rounded-full bg-primary-900/70 text-background-200 text-xs whitespace-nowrap"
                >
                  {word}
                </span>
              ))}
            </div>
            <p className="mt-5 text-xs text-background-400 leading-relaxed">
              内容为娱乐化表达，不指向具体个人；如有侵权或不当信息，欢迎通过邮箱反馈。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900/60">
        <div className="container-page py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} {site.brand} · 吃瓜娱乐二创内容聚合站</p>
          <p className="flex items-center gap-4 flex-wrap justify-center">
            <span>{site.updateTime}</span>
            <Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">
              关于我们
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}